<template lang="html">
    <div id="logs" class="center-panel">
        <md-content md-theme="white" v-loader-overlay="progress">
            <sort-table ref="table" v-bind:table-id="'logs-list'" v-bind:columns="tableColumns" v-model="logs" v-on:refresh="getLogs" v-bind:per-page="perPage" v-bind:total="logsAmount" v-bind:showAddButton="false" link>
                <span slot="user"      slot-scope="scope">{{ (scope.item.user ? scope.item.user.fio + ' (' + scope.item.user.login + ')' : '') }}</span>
                <span slot="module"    slot-scope="scope">{{ scope.item.module.description }}</span>
                <span slot="action"    slot-scope="scope">{{ scope.item.action.name }}</span>
                <span slot="entity_id" slot-scope="scope">{{ scope.item.entity_id }}</span>
                <template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>
<script>
    import SortTable   from "@/components/SortTable";
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: {SortTable, ZIconButton},
        data() {
            return {
                tableColumns: [
                    { label: 'ID',           field: 'id',         sortable: true},
                    { label: 'Событие',      field: 'action',     sortable: true},
                    { label: 'Дата',         field: 'created_at', sortable: true, default: true,},
                    { label: 'Пользователь', field: 'user',       sortable: true},
                    { label: 'Модуль',       field: 'module',     sortable: true},
                    { label: 'ID сущности',  field: 'entity_id',  sortable: true},
                    { label: '',             field: 'actions' },
                ],
                perPage: 50
            }
        },
        computed: {
            /**
             * Список историй
             */
            logs() {
                return this.$store.state.logs.logs.map(log => {
                    log.routerLink = {name: 'Log', params: {log_id: log.id}, query: this.$route.query};
                    return log;
                });
            },
            /**
             * Количество историй
             */
            logsAmount() {
                return this.$store.state.logs.logs_amount;
            },
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-logs-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            }
        },
        created() {
            this.$store.commit('setTitle', 'История');
        },
        methods: {
            /**
             * Вытаскивает фильтр из URL и форматирует его в коррктный вид для запроса, в формате:
             * {model: [['field', 'condition', 'value'], 'and|or', ['field', 'condition', 'value']]}
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return null;
                let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), model = [], result = {model: []};

                if (filter.date_from) model.push(['created_at', '>=', this.moment(filter.date_from).format('YYYY-MM-DD')]);
                if (filter.date_to)   model.push(['created_at', '<=', this.moment(filter.date_to).format('YYYY-MM-DD')]);
                if (filter.module_id) model.push(['module_id',  '=',  parseInt(filter.module_id)]);
                
                model.map((item, i) => {
                    result.model.push(item);
                    if (model[i+1]) result.model.push('and');
                });
                
               return result;
            },
            /**
             * Получение историй
             */
            getLogs(page, count, orderBy, orderType) {
                this.$store.commit('showProgressBar', 'get-logs-list');
                this.$store.dispatch('logs/getAllLogs', {
                    order_by:   orderBy,
                    order_type: orderType,
                    page:   page,
                    count:  count,
                    filter: this.resolveQueryFilter()
                }).finally(() => this.$store.commit('hideProgressBar', 'get-logs-list'));
            },
            /**
             * Удаление истории
             */
            removeLog(id) {
                if (!id) return;
                this.$store.commit('showProgressBar', 'get-logs-list');
                this.$store.dispatch('logs/removeLog', id)
                    .then(() => this.$root.$emit('refresh-table', 'logs-list'))
                    .finally(() => this.$store.commit('hideProgressBar', 'get-logs-list'));
            },
            /**
             * Модальное окно с подтверждением удаления истории
             */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении записи?', 'Действие необратимо!',
                    () => this.removeLog(id)
                );
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Logs.vue?03cfe924